import Vue from 'vue';
import App from './App.vue';
import store from '@/store';
import { Popup, Picker, Loading, ActionSheet, List, PullRefresh, Overlay, Field } from 'vant';
import VueClipboard from 'vue-clipboard2';
import Toast from '@/components/IToast';
import moment from 'moment';
import router from './router';
import '@/assets/styles/reset.css';
import '@/assets/styles/common.css';
import '@/assets/fonts/Oswald-Medium/Oswald-Medium.css';
import './commonImports';
import './extensions';
import './permision';
import CoolMobileUI from '@igetcool/cool-mobile-ui';
import vconsole from 'vconsole';
const isVconsole = location.search.includes('isvconsole');

if (isVconsole || process.env.VUE_APP_ENVIRONMENT === 'QA' || process.env.VUE_APP_ENVIRONMENT === 'DEVELOPMENT') {
  new vconsole();
}
import * as filters from './filters';

Vue.config.productionTip = false;
Vue.use(Popup);
Vue.use(Picker);
Vue.use(ActionSheet);
Vue.use(Loading);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Overlay);
Vue.use(VueClipboard);
Vue.use(CoolMobileUI);
Vue.use(Field);

Vue.filter('dateFmt', (input, fmtstring) => {
  return moment(input).format(fmtstring);
});

Vue.directive('drag', {
  bind(el) {
    let touch, disX, disY, elHeight;
    let winHeight = document.body.clientHeight;
    el.ontouchstart = function(e) {
      elHeight = el.offsetHeight;
      if (e.touches) {
        touch = e.touches[0];
      } else {
        touch = e;
      }
      disY = touch.clientY - el.offsetTop;
    };
    el.ontouchmove = function(e) {
      if (e.touches) {
        touch = e.touches[0];
      } else {
        touch = e;
      }
      let top = touch.clientY - disY;
      if (top <= 0) { top = 0 }
      if (top >= winHeight - elHeight) { top = winHeight - elHeight }

      //  移动dom
      el.style.top = `${top}px`;
      e.preventDefault();
    };
  }
});

import prompter from '@/components/Prompter/index.js';
Vue.prototype.$prompter = prompter;

// 埋点上报全局引用
import { logReport } from '@/utils/logReport';
Vue.prototype.$logReport = logReport;
// let hideWords = '语文,历史,地理,数学,英语,日语,俄语,物理,化学,生物,小学,中学,中小学,中考,高考,考试,成绩,新课标,阅读,启蒙,教材,学科,必读,必学,教育部,提分,作文,历史,学习,必考,初中,复习,数理化,史地生,小升初,幼升小,训练营';
let hideWords = '';
Vue.prototype.$hideWordsArray = hideWords ? hideWords.split(',') : [];

// 注册长按指令
// import LongPress from '@/directive/longpress.js'
// Vue.use(LongPress, {time: 1000})

// localStorage.clear()
Vue.prototype.$toast = Toast;

// 新增-火山埋点
import logTrackInstance, { commonParams } from '@utils/logTrack';
// Vue.prototype.$logTrack = logTrackInstance;
Vue.prototype.$tracker = (evnetName, params = {}) => {
  params = Object.assign({}, commonParams, params);
  logTrackInstance.logTrack(evnetName, params);
};

// 注册全局filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
